// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".outer-circle[data-v-0ffc1124]{animation:spin-0ffc1124 1.5s linear infinite;border-style:solid}.inner-circle[data-v-0ffc1124]{animation:spin-back-0ffc1124 1s linear infinite;border-style:solid}@keyframes spin-0ffc1124{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}@keyframes spin-back-0ffc1124{0%{transform:rotate(0deg)}to{transform:rotate(-2turn)}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
